import { render, staticRenderFns } from "./EmailSideBar.vue?vue&type=template&id=97724cca"
import script from "./EmailSideBar.vue?vue&type=script&lang=js"
export * from "./EmailSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports